// Work-in-progress persistence (text + last result) so a mobile tab reload doesn't wipe it.
const KEY = "sux1_draft";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const MAX_TEXT_CHARS = 1500000;

export function readDraft() {
  try {
    const d = JSON.parse(localStorage.getItem(KEY) || "{}");
    if (!d.ts || Date.now() - d.ts > MAX_AGE_MS) return {};
    return d;
  } catch {
    return {};
  }
}

export function saveDraft({ text, result, chaptersResult, mode }) {
  const base = { ts: Date.now(), result, chaptersResult, mode };
  const full = { ...base, text: text && text.length <= MAX_TEXT_CHARS ? text : "" };
  try {
    if (!text && !result && !chaptersResult) {
      localStorage.removeItem(KEY);
      return;
    }
    localStorage.setItem(KEY, JSON.stringify(full));
  } catch {
    try { localStorage.setItem(KEY, JSON.stringify(base)); } catch { /* quota */ }
  }
}

export function clearDraft() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
